// extracted by mini-css-extract-plugin
export const container = "random-module--container--2Rq-K";
export const icon = "random-module--icon--3hvVx";
export const map = "random-module--map--1ozFE";
export const star = "random-module--star--3ZN3B";
export const dogOuter = "random-module--dog-outer--186Sm";
export const random = "random-module--random--3xvJ-";
export const tag = "random-module--tag--2R7qM";